import { render, staticRenderFns } from "./SaveTemplateModal.vue?vue&type=template&id=6bc4eaa4&scoped=true&"
import script from "./SaveTemplateModal.vue?vue&type=script&lang=js&"
export * from "./SaveTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveTemplateModal.vue?vue&type=style&index=0&id=6bc4eaa4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc4eaa4",
  null
  
)

export default component.exports